module.exports = __webpack_public_path__ + "img/ico_attZIP.f9bc23ef.png";